import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import {
  type TermsMethodsKindEnum,
  TermsMethodsKinds,
} from '@webapp/modules/purchasing/entities/enums/TermsMethodsKindEnum'
// eslint-disable-next-line import/no-internal-modules
import { paymentTermRepository } from '@webapp/modules/vendor/data-access/repositories/PaymentTermRepository'
// eslint-disable-next-line import/no-internal-modules
import { shippingMethodRepository } from '@webapp/modules/vendor/data-access/repositories/ShippingMethodRepository'
// eslint-disable-next-line import/no-internal-modules
import { shippingTermRepository } from '@webapp/modules/vendor/data-access/repositories/ShippingTermRepository'
import {
  paymentTermQueryConfig,
  shippingMethodQueryConfig,
  shippingTermQueryConfig,
} from '@webapp/modules/vendor/query-configs' // eslint-disable-line import/no-internal-modules

interface CreateTermOrMethodMutationVariables {
  name: string
  description: string
}

// Kind-switch lives in the Model layer, not the Feature Set
const KIND_REPOSITORIES = {
  [TermsMethodsKinds.SHIPPING_TERMS]: shippingTermRepository,
  [TermsMethodsKinds.PAYMENT_TERMS]: paymentTermRepository,
  [TermsMethodsKinds.SHIPPING_METHODS]: shippingMethodRepository,
} as const

const KIND_QUERY_CONFIGS = {
  [TermsMethodsKinds.SHIPPING_TERMS]: shippingTermQueryConfig,
  [TermsMethodsKinds.PAYMENT_TERMS]: paymentTermQueryConfig,
  [TermsMethodsKinds.SHIPPING_METHODS]: shippingMethodQueryConfig,
} as const

export const useMutateCreateTermOrMethod = (kind: TermsMethodsKindEnum) => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    { id: number },
    RepoError,
    CreateTermOrMethodMutationVariables
  >({
    mutationFn: (values) =>
      KIND_REPOSITORIES[kind].create({
        name: values.name,
        description: values.description,
      }),
    onSuccess: () => {
      // Per-kind isolation — invalidate only the active kind's aggregate
      queryClient.invalidateQueries({
        queryKey: KIND_QUERY_CONFIGS[kind].all().queryKey,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
